import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { overrideConfig } from '@/components/widget/visualizations/internal/LineChart/utils';
import { useLineStyles } from '@/components/widget/visualizations/internal/LineChart/stylesTheme';
import Label from '@/components/FormElements/Label';
import Select from '@/components/FormElements/Select';
import RevealPill from '@/components/Editor/Form/fields/RevealPill';
import parentStyles from '@/features/WidgetEdit/Form/styles.module.scss';

var ChartLineGraphIcon = function ChartLineGraphIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_8029_826)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.278 0.0539649C18.8311 0.238313 19.1299 0.836086 18.9456 1.38913L16.8592 7.64848C16.1147 9.88168 13.2804 10.5508 11.6159 8.88624L10.1133 7.38367C9.55848 6.82882 8.61371 7.05186 8.36557 7.79626L6.27912 14.0556C6.09478 14.6086 5.497 14.9075 4.94396 14.7232C4.39092 14.5388 4.09203 13.9411 4.27638 13.388L6.36283 7.12868C7.10723 4.89547 9.94155 4.22638 11.6061 5.89091L13.1087 7.39348C13.6635 7.94833 14.6083 7.72529 14.8564 6.98089L16.9429 0.721547C17.1272 0.168504 17.725 -0.130383 18.278 0.0539649Z",
        fill: "#12131A"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.625 18.1667C0.625 17.4993 1.16599 16.9583 1.83333 16.9583L21.1667 16.9583C21.834 16.9583 22.375 17.4993 22.375 18.1667C22.375 18.834 21.834 19.375 21.1667 19.375L1.83333 19.375C1.16599 19.375 0.625 18.834 0.625 18.1667Z",
        fill: "#8C8C8C"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_8029_826",
        children: /*#__PURE__*/_jsx("rect", {
          width: "23",
          height: "20.0005",
          fill: "white",
          transform: "translate(0 -0.000488281)"
        })
      })
    })]
  }));
};

ChartLineGraphIcon.defaultProps = {
  width: "23",
  height: "20",
  viewBox: "0 0 23 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ChartAreaIcon = function ChartAreaIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_7784_1428)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M0 15.3351V12.9789L7.97003 10.3222C8.57498 10.1206 9.22489 10.0956 9.84353 10.2503L13.0511 11.0522C13.2574 11.1037 13.474 11.0954 13.6756 11.0282L22.3529 8.13574V10.4919L14.3825 13.1488C13.7776 13.3504 13.1276 13.3754 12.509 13.2207L9.30139 12.4188C9.09518 12.3673 8.87854 12.3756 8.67689 12.4428L0 15.3351Z",
        fill: "#8C8C8C"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.1176 4.47294C20.1176 3.57415 19.1106 3.04301 18.3688 3.55056L14.8723 5.9431C14.0811 6.48454 13.0958 6.66133 12.1657 6.42879L9.54144 5.77273C9.26186 5.70283 8.96608 5.74363 8.71587 5.88662L2.79843 9.26801C2.4502 9.467 2.23529 9.83732 2.23529 10.2384V15.6471C2.23529 16.2643 2.73568 16.7647 3.35294 16.7647H19C19.6173 16.7647 20.1176 16.2643 20.1176 15.6471V4.47294ZM17.1065 1.7058C19.3318 0.18313 22.3529 1.77658 22.3529 4.47294V15.6471C22.3529 17.4989 20.8518 19 19 19H3.35294C1.50116 19 0 17.4989 0 15.6471V10.2384C0 9.03517 0.644724 7.9242 1.68942 7.32723L7.60685 3.94584C8.3575 3.51689 9.24483 3.39449 10.0836 3.60417L12.7078 4.26023C13.0179 4.33775 13.3463 4.27882 13.61 4.09834L17.1065 1.7058Z",
        fill: "#12131A"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_7784_1428",
        children: /*#__PURE__*/_jsx("rect", {
          width: "22.3529",
          height: "19",
          fill: "white"
        })
      })
    })]
  }));
};

ChartAreaIcon.defaultProps = {
  width: "23",
  height: "19",
  viewBox: "0 0 23 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ChartStackedAreaIcon = function ChartStackedAreaIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_7784_1436)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M23.75 2.38357C23.75 0.601579 21.8604 -0.545676 20.2794 0.276373L14.5007 3.28094C14.2435 3.41469 13.9462 3.4497 13.6649 3.37938L10.2509 2.52589C9.65679 2.37736 9.02827 2.46406 8.49656 2.7679L1.19667 6.93926C0.45668 7.36212 0 8.14906 0 9.00134V16.6247C0 17.9364 1.06332 18.9997 2.375 18.9997H21.375C22.6867 18.9997 23.75 17.9364 23.75 16.6247V2.38357Z",
        fill: "#12131A",
        fillOpacity: "0.25"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.4613 11.0771L0.770541 13.9611C0.307055 14.1349 0 14.578 0 15.073V16.6251C0 17.9368 1.06332 19.0001 2.375 19.0001H21.375C22.6867 19.0001 23.75 17.9368 23.75 16.6251V9.5001C23.75 8.67098 22.9219 8.09708 22.1455 8.38821L15.2887 11.4856C14.6123 11.7392 13.8747 11.7812 13.1738 11.606L10.5762 10.9566C9.87533 10.7814 9.13775 10.8234 8.4613 11.0771Z",
        fill: "#12131A"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_7784_1436",
        children: /*#__PURE__*/_jsx("rect", {
          width: "23.75",
          height: "19",
          fill: "white"
        })
      })
    })]
  }));
};

ChartStackedAreaIcon.defaultProps = {
  width: "24",
  height: "19",
  viewBox: "0 0 24 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const CHART_STYLE_ICONS = {
  line: ChartLineGraphIcon,
  area: ChartAreaIcon,
  stackedArea: ChartStackedAreaIcon
};

const ChartStyle = _ref => {
  let {
    config,
    openButtonVariant,
    onChange
  } = _ref;
  const {
    lineThemeStyles
  } = useLineStyles(config);
  const {
    chartStyle = 'line'
  } = overrideConfig(config);
  const ChartStyleIconComponent = CHART_STYLE_ICONS[chartStyle];
  return /*#__PURE__*/_jsxs(RevealPill, {
    label: "Chart Style",
    openButtonVariant: openButtonVariant,
    activeState: /*#__PURE__*/_jsx(ChartStyleIconComponent, {
      className: styles.icon
    }),
    children: [/*#__PURE__*/_jsx(Label, {
      className: parentStyles.formField,
      text: "Chart Style",
      children: /*#__PURE__*/_jsxs(Select, {
        defaultValue: chartStyle,
        onChange: evt => {
          var _evt$currentTarget;

          const value = ((_evt$currentTarget = evt.currentTarget) === null || _evt$currentTarget === void 0 ? void 0 : _evt$currentTarget.value) || '';
          onChange('', {
            chartStyle: value
          });
        },
        children: [/*#__PURE__*/_jsx("option", {
          value: "line",
          children: "Line"
        }), /*#__PURE__*/_jsx("option", {
          value: "area",
          children: "Area"
        }), /*#__PURE__*/_jsx("option", {
          value: "stackedArea",
          children: "Stacked Area"
        })]
      })
    }), chartStyle && chartStyle !== 'line' ? /*#__PURE__*/_jsx(Label, {
      className: parentStyles.formField,
      text: "Default Area Fill",
      caption: {
        fade: 'Line fill colors automatically fade into transparency',
        transparent: 'Line fill colors are transparent and partially see-through',
        solid: 'Line fill colors are completely filled and opaque'
      }[lineThemeStyles.areaChartDefaultFill || 'fade'],
      children: /*#__PURE__*/_jsxs(Select, {
        defaultValue: lineThemeStyles.areaChartDefaultFill,
        onChange: evt => {
          var _evt$currentTarget2;

          const value = ((_evt$currentTarget2 = evt.currentTarget) === null || _evt$currentTarget2 === void 0 ? void 0 : _evt$currentTarget2.value) || '';
          onChange('', {
            areaChartDefaultFill: value
          });
        },
        children: [/*#__PURE__*/_jsx("option", {
          value: "fade",
          children: "Fade"
        }), /*#__PURE__*/_jsx("option", {
          value: "transparent",
          children: "Transparent"
        }), /*#__PURE__*/_jsx("option", {
          value: "solid",
          children: "Solid"
        })]
      }, chartStyle)
    }) : /*#__PURE__*/_jsx(_Fragment, {})]
  });
};

export default ChartStyle;